import copyProps from './copy-props';

export default function addClassName(inProps, klass) {
  const props = copyProps(inProps);
  props.className = props.className ?
    `${klass} ${props.className}` : klass;

  return props;
}
